import { ChevronRightIcon } from "@heroicons/react/24/outline"

const Breadcrumbs = ({ items = [] }) => {
  if (!items || items.length === 0) return null

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center my-0 gap-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <ChevronRightIcon className="w-3.5 h-3.5 text-text_secondary shrink-0" />
              )}
              {!isLast && item.link ? (
                <a
                  href={item.link}
                  onClick={(e) => { e.preventDefault(); if (item.onClick) item.onClick() }}
                  className="text-sm text-text_secondary hover:text-primary transition-colors cursor-pointer no-underline"
                >
                  {item.label}
                </a>
              ) : (
                <span className={`text-sm ${isLast ? "text-text font-medium" : "text-text_secondary"}`}>
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
